import React, { useEffect, useState } from 'react'
import { ComandaItem, ComandaInfo } from '../../types'
import {
  MarkComandaAsStarted,
  MarkComandaAsReady
} from '../../../../../../crud/pedidos_api/comandas'
import { FaPlayCircle } from 'react-icons/fa'
import './ComandaCard.scss'

// entry type
interface Entry {
  entryId: number
  comanda: {
    comanda_id: number
    info: ComandaInfo;
    items: ComandaItem[]
    terminal: { terminal_name: string }
  }
  batchId: number
  companions: ComandaItem[]
  status: 'start'|'ready'
  timestamp: number
}

interface Props {
  e: Entry;
  entries: Entry[];
  setEntries: any;
  batchColorRef: React.RefObject<Map<number,string>>;
}

// live timer helper
const computeElapsed = (ts: number) => {
  const d = Date.now() - ts
  const m = Math.floor(d/60000) 
  const s = Math.floor((d%60000)/1000)
  return `${m}m ${s}s`
}

const ComandaCard: React.FC<Props> = ({
  e, entries, setEntries, batchColorRef
}) => {
  const [elapsed, setElapsed] = useState(computeElapsed(e.timestamp))

  useEffect(() => {
    const id = setInterval(
      () => setElapsed(computeElapsed(e.timestamp)),
      1000
    )
    return () => clearInterval(id)
  }, [e.timestamp])

  const toggleStatus = async () => {
    if (e.status === 'start') {
      await MarkComandaAsStarted(e.entryId)
      setEntries((cur:any) =>
        cur.map((x:any) =>
          x.entryId === e.entryId
            ? { ...x, status: 'ready' }
            : x
        )
      )
    } else {
      await MarkComandaAsReady(e.entryId)
      setEntries((cur:any) =>
        cur.filter((x:any) => x.entryId !== e.entryId)
      )
    }
  }

  const renderProviderLogo = (id: number | string) => {
    const providerFiLenameMap: Record<number, string> = {
      1:'uber-eats.png',
      2:'rappi.png',
      3:'pedidos-ya.png',
      4:'JUSTO.png',
      7:'didi-food.jpg',
    }
    const filename = providerFiLenameMap[id as number] || 'logo.png'
    return(
      <div className="delivery-provider-logo">
        <img 
          alt="logo"
          className="logo-img"
          src={`${process.env.PUBLIC_URL}/icons/providers/${filename}`} 
        />
    </div>
    )
  }


  const borderColor = batchColorRef.current!.get(e.batchId) || 'transparent'

  return (
    <div
      className="comanda-card"
      style={{ borderTop:`4px solid ${borderColor}` }}
    >
      <header>
        {(e.comanda.info.third_party_provider_id !== null) && renderProviderLogo(e.comanda.info.third_party_provider_id)}
        <div className='comanda-info'>
          <div className="mesa-KDS">
          {(e.comanda.info.pedido_type_id === 1) ? `Mesa ${e.comanda.info.mesa}` : ''}

          {(e.comanda.info.pedido_type_id === 2) && `${e.comanda.info.client} (${String(e.comanda.info.pedido_id).slice(-5)})`}

          {(e.comanda.info.pedido_type_id === 3 && e.comanda.info.third_party_provider_id === null) ?
           `${e.comanda.info.client} (${String(e.comanda.info.pedido_id).slice(-5)})` : ''}

          {(e.comanda.info.pedido_type_id === 3 && e.comanda.info.third_party_provider_id !== null) ?
             `#${e.comanda.info.pedido_id}` : ''
           }

           {(e.comanda.info.pedido_type_id === 4) && `Mostrador - ${e.comanda.info.pedido_id}`}
           </div>
          <div className="user">
            {(e.comanda.info.pedido_type_id === 1) && e.comanda.info.user}
            {(e.comanda.info.pedido_type_id === 2 || e.comanda.info.pedido_type_id === 3 ) && e.comanda.info.client}
            </div>
        </div>
        <div className="time">{elapsed}</div>
      </header>

      <section className="items">
        <ul>
          {e.comanda.items.map((it,i)=>(
            <li key={i}>
              {it.text}
              {it.comment && <small className="comment">"{it.comment}"</small>}
            </li>
          ))}
        </ul>

        {e.companions.length > 0 && (
          <div className="companions">
            Va con:
            <div className="comp-list">
              {e.companions.map((c,i)=>(
                <span key={i} className="comp-item">{c.text}</span>
              ))}
            </div>
          </div>
        )}
      </section>

      <footer>
        <button
          className={`start-btn ${e.status}`}
          onClick={toggleStatus}
        >
          {e.status==='start' ? 'Comenzar ' : 'Listo '}
          <FaPlayCircle className="play-icon"/>
        </button>
        <div className="terminal">
          {e.comanda.terminal.terminal_name}
        </div>
      </footer>
    </div>
  )
}

export default ComandaCard
